import header from './header';
import navigation from './navigation';
import footer from './footer';
import termsOfService from './termsOfService';
import forms from './forms';
import main from './main';
import demo from './demo';
import appBar from './appBar';
import event from './event';
import appointmentBlock from './appointmentBlock';
import appointmentResultCard from './appointmentResultCard';
import confirmation from './confirmation';
import debug from './debug';
import appOffline from './appOffline';
import countdownTimer from './countdownTimer';
import error from './error';
import loadingScreen from './loadingScreen';
import skeleton from './skeleton';

export default (theme) => ({
  '@global': {
    // border-box so width: 100% + padding doesn't overflow the container.
    '*, *::before, *::after': {
      boxSizing: 'border-box',
    },
    // Keep focused elements clear of the sticky header (WCAG 2.4.11).
    html: {
      scrollPaddingTop: 'var(--sticky-header-h, 0px)',
    },
    body: {
      margin: 0,
      padding: 0,
    },
  },
  root: {
    // display: "flex",
  },
  hide: {
    display: 'none',
  },
  centerText: {
    textAlign: 'center',
  },
  skipContent: {
    '& a': {
      position: 'absolute',
      left: '-10000px',
      top: 'auto',
      width: '1px',
      height: '1px',
      overflow: 'hidden',
    },
    '& a:focus': {
      position: 'static',
      width: 'auto',
      height: 'auto',
    },
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  ...appBar,
  ...header,
  ...navigation,
  ...footer,
  ...main,
  ...forms,
  ...demo,
  ...event(theme),
  ...appointmentBlock,
  ...appointmentResultCard,
  ...confirmation,
  ...debug,
  ...appOffline,
  ...termsOfService,
  ...countdownTimer,
  ...error,
  ...loadingScreen,
  ...skeleton,
});
